import { token } from '@atlaskit/tokens';

export const TODO_COLOR = token('color.border');
export const IN_PROGRESS_COLOR = token('color.border.information');
export const DONE_COLOR = token('color.border.success');
export const WARNING_COLOR = token('color.background.warning.bold.hovered');
